module.exports = __webpack_public_path__ + "static/media/production-qr.83848af9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/production-qr.png
// module id = 713
// module chunks = 21